import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterState } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { PedidosService } from '../servicios/pedidos.service';
import { MensajesRespuestas } from './../../../shared/constants/mensajeRespuesta';
import { Mensaje } from './../../../shared/models/mensaje';
import { TiposMensajes } from './../../../shared/models/tipos-mensajes';

@Component({
  selector: 'app-mensajes',
  templateUrl: './mensajes.component.html',
  styleUrls: ['./mensajes.component.scss'],
})
export class MensajesComponent implements OnInit {
  mensajes: Mensaje[];

  constructor(
    private pedidorService: PedidosService,
    private activatedRoute: ActivatedRoute,
    private SpinnerService: NgxSpinnerService,
    private router: Router
  ) {
    this.activatedRoute.params.subscribe(() => {
      const state: RouterState = router.routerState;
      if (this.activatedRoute.snapshot.params.usr) {
        this.getMensajes(this.activatedRoute.snapshot.params.usr).subscribe(
          (mensajes) => {
            if (
              mensajes[0]['id_response'] === MensajesRespuestas.NO_HAY_DATOS
            ) {
              mensajes = null;
            } else {
              this.mensajes = mensajes;
            }
          }
        );
      }
    });
  }

  ngOnInit(): void {}

  getMensajes(usuario: string): Observable<Mensaje[]> {
    this.SpinnerService.show();
    return this.pedidorService.getMensajes(usuario).pipe(
      tap(() => this.SpinnerService.hide()),
      map((mensajes) => {
        return mensajes;
      })
    );
  }

  getMensajesAcum(usuario: string): Observable<TiposMensajes> {
    return this.pedidorService.getMensajes(usuario).pipe(
      map((mensajes) => {
        return mensajes.reduce(
          (acumulador: TiposMensajes, mensaje: Mensaje) => {
            if (mensaje.tipo === 1) {
              acumulador.success.push(mensaje);
            } else if (mensaje.tipo === 2) {
              acumulador.info.push(mensaje);
            } else if (mensaje.tipo === 3) {
              acumulador.warning.push(mensaje);
            } else {
              acumulador.error.push(mensaje);
            }
            return acumulador;
          },
          { success: [], warning: [], info: [], error: [] }
        );
      })
    );
  }
}
